<!-- <div *ngIf="loading$ | async" class="loading-indicator">
    Loading...
  </div> -->

<!-- Visibilidad de la lista -->
<div class="container mx-auto max-w-screen-xl px-3 sm:px-6 lg:px-8 grid grid-cols-12 gap-4">
  <div class="col-span-12 md:col-span-12">
    <div
      id="accordion-flush"
      data-accordion="collapse"
      data-active-classes="text-gray-500 dark:text-gray-400"
      data-inactive-classes="text-gray-500 dark:text-gray-400"
    >
      <div
        class="editor flexi mx-auto flex flex-col text-gray-800 border-gray-300 mb-3 rounded-xl border p-3 shadow-md bg-white"
      >
        <h2 id="accordion-flush-heading-1" class="mb-0">
          <button
            type="button"
            class="flex items-center justify-between w-full py-2 font-medium rtl:text-right text-gray-500 dark:border-gray-700 dark:text-gray-400 gap-3"
            data-accordion-target="#accordion-flush-body-1"
            aria-expanded="true"
            aria-controls="accordion-flush-body-1"
          >
            <span>My Groups</span>
            <svg
              data-accordion-icon
              class="w-3 h-3 rotate-180 shrink-0"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5 5 1 1 5"
              />
            </svg>
          </button>
        </h2>
        <div
          id="accordion-flush-body-1"
          class="hidden my-3"
          aria-labelledby="accordion-flush-heading-1"
        >
          <p>
            Create a group and add members to participate in a consensus workshop. The goal is to
            reach a mutually agreed-upon research topic that aligns with the interests of all team
            members. 🎯📚
          </p>
          <div class="dark:border-gray-700">
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <btn-create-group></btn-create-group>
              <ng-container *ngFor="let group of groups">
                <card-group
                  [group]="group"
                  [isOwner]="isOwnerMap[group.id]"
                  (navigate)="navigateToGroup(group.id)"
                ></card-group>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div
        class="editor flexi mx-auto flex flex-col text-gray-800 border-gray-300 mb-3 rounded-xl border p-3 shadow-md bg-white"
      >
        <h2 id="accordion-flush-heading-2" class="mb-0">
          <button
            type="button"
            class="cursor-not-allowed flex items-center justify-between w-full py-2 font-medium rtl:text-right text-gray-500 dark:border-gray-700 dark:text-gray-400 gap-3"
            data-accordion-target="#accordion-flush-body-2"
            aria-expanded="false"
            aria-controls="accordion-flush-body-2"
            disabled
          >
            <span>Recommended Groups</span>
            <svg
              data-accordion-icon
              class="w-3 h-3 rotate-180 shrink-0"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5 5 1 1 5"
              />
            </svg>
          </button>
        </h2>
        <div id="accordion-flush-body-2" class="hidden" aria-labelledby="accordion-flush-heading-2">
          <div class="py-5 dark:border-gray-700">
            <ng-container *ngFor="let group of groups">
              <card-group [group]="group" (navigate)="navigateToGroup(group.id)"></card-group>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
